import { put, takeEvery } from 'redux-saga/effects';
import { refreshView, refreshPopupView } from 'store/actions/listActions';

function* handleRefresh({meta: { popup = false, refresh }}) {
    const isPopup = refresh.popup !== undefined ? refresh.popup : popup;

    if(isPopup) {
        return yield put(refreshPopupView()); 
    }
    yield put(refreshView());
}

export default function* refresh() {
    yield takeEvery(
        action => action.meta && action.meta.refresh,
        handleRefresh
    );
}